import { useParams } from "react-router-dom";

const FormViewer = () => {
  const { formId } = useParams(); // e.g. 'form-iii', 'form-iv'

  const formLabel = formId.toUpperCase().replace(/-/g, ' ');
  const pdfPath = `/forms/${formLabel}.pdf`;
  const docxPath = `/forms/${formLabel}.docx`;

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white shadow-xl rounded-xl relative">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">📄 {formLabel}</h2>
        <a
          href={docxPath}
          download
          className="bg-purple-600 hover:bg-purple-700 text-white font-bold px-5 py-2 rounded shadow"
        >
          📥 Download Word File
        </a>
      </div>
      <iframe
        src={pdfPath}
        title={formLabel}
        width="100%"
        height="750px"
        className="rounded border border-gray-300 shadow-md"
      ></iframe>
    </div>
  );
};

export default FormViewer;
